@if ((impressum$ | async); as impressum) {
  <div class="accordeon-tab">
    <input type="checkbox" id="impressum-toggle" class="acordeon">
    <label class="accordeon-tab-label" for="impressum-toggle"><h2>{{impressum.data.attributes.titel | uppercase}}</h2></label>
    <div class="accordeon-tab-content">
      <span [innerHtml]="impressum.data.attributes.text"></span><br>
    </div>
  </div>
}